import styled from '@emotion/styled';
import {Button, Chip} from '@bosch/react-frok';

export const LocalesWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 1.3rem;
`;

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-grid;
    grid-template-columns: 2fr 3fr 3fr 1fr;
    column-gap: 0.5rem;
    width: 100%;
`;

export const LocalesSelectionWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

export const LocalesContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    max-height: 8rem;
    overflow-y: auto;
    margin-top: 1rem;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 1rem 0 0 0;
    min-width: 120px;
    max-width: 200px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

export const Locales = styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;
